import React, { useState, useEffect } from "react";
import Axios from "axios";
import "../App.css";
import { useNavigate, useLocation } from "react-router-dom";
import appIcon from "../assets/images/appIcon_round.webp";
import background from "../assets/images/backckground_2.jpg";
import $ from "jquery";
export default () => {
  const [msg, setMsg] = useState("");
  const [userID, setUserID] = useState("");
  const [isEmptyUserID, setisEmptyUserID] = useState(false);
  const [isEmptyPassword, setisEmptyPassword] = useState(false);
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const onSignin = (e) => {
    if (userID == "") {
      setMsg("Please enter your phone number");
    } else if (password == "") {
      setMsg("Please enter your password");
    } else {
      e.preventDefault();
      let formdata = $(e.target);
      formdata = new FormData();
      formdata.append("user_id", userID);
      formdata.append("password", password);
      formdata.append('MDT', 'PM');
      $.ajax({
        type: "POST",
        url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/AuthController/authenticate_patient_by_userId`,
        data: formdata,
        processData: false,
        contentType: false,
        success(data) {
          console.log("Login Success::::", data);
          localStorage.setItem("user_id", data?.user_id);
          localStorage.setItem("phoneNo", data?.phone_number);
          localStorage.setItem("token", data.token);
          navigate("/");
        },
        error: function (err) {
          const response = JSON.parse(err.responseText);
          console.log("Login Error", err.responseText);
          setMsg(response.message);
        },
      });
    }
  };
  const onUserIdUpdate = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setUserID(value);
    }
  };
  return (
    <div className="background-container">
      <div
        style={{
          width: "80%",
          height: "100%",
          // backgroundColor: "#f8f9fa", // Light color
          borderRadius: "15px", // Rounded corners
          boxShadow:
            "0px 4px 6px rgba(0, 0, 0, 0.5), 0px 1px 3px rgba(0, 0, 0, 0.06)", // 3D shadow effect

          justifyContent: "center",
          alignItems: "center",
          position: "absolute",

          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Centers the box
        }}
      >
        <img src={appIcon} style={{ height: 130, width: 130, marginTop: 5 }} />
        <div>
          <h3
            style={{
              textAlign: "center",
              marginTop: 50,
              fontWeight: "bold",
              fontSize: 24,
            }}
          >
            Sign In
          </h3>
        </div>
        <div>
          <div style={{ textAlign: "center" }}>
            <div
              style={{
                textAlign: "left",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <a
                style={{
                  textDecoration: "none",
                  fontSize: 15,
                  fontWeight: "600",
                }}
              >
                User ID
              </a>
            </div>
            <input
              onChange={onUserIdUpdate}
              value={userID}
              style={{
                border: "1px solid rgb(185, 184, 184)",
                backgroundColor: "#DDDDDD",
                color: "black",
                width: "100%",
                height: 40,
                fontSize: 16,
                borderRadius: 8,
                // marginTop: 50,
                textAlign: "center",
              }}
              type="text"
              placeholder=" Enter your phone number"
              maxLength={10}
            />
          </div>

          <div style={{ marginTop: 5, textAlign: "center" }}>
            {isEmptyUserID ? (
              <p style={{ fontSize: 16, fontWeight: "bold", color: "red" }}>
                Please enter your user id
              </p>
            ) : null}
          </div>
        </div>
        {/* password------- */}
        <div>
          <div style={{ textAlign: "center" }}>
            <div
              style={{
                textAlign: "left",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <a
                style={{
                  textDecoration: "none",
                  fontSize: 15,
                  fontWeight: "600",
                }}
              >
                Password
              </a>
            </div>
            <input
              onChange={(e) => setPassword(e.target.value)}
              style={{
                border: "1px solid rgb(185, 184, 184)",
                backgroundColor: "#DDDDDD",
                color: "black",
                width: "100%",
                height: 40,
                fontSize: 16,
                borderRadius: 8,
                // marginTop: 50,
                textAlign: "center",
              }}
              type="password"
              placeholder="Enter password"
              maxLength={20}
            />
          </div>

          <div style={{ marginTop: 5, textAlign: "center" }}>
            {isEmptyPassword ? (
              <p style={{ fontSize: 16, fontWeight: "bold", color: "red" }}>
                Please enter password
              </p>
            ) : null}
          </div>
        </div>

        {msg ? (
          <p
            style={{
              fontSize: 16,
              fontWeight: "bold",
              color: "red",
              marginTop: 10,
            }}
          >
            {msg}
          </p>
        ) : null}
        <button className="otp_button" onClick={onSignin}>
          SIGN IN
        </button>
        <div style={{ marginTop: 20, textAlign: "center" }}>
          <p>or</p>
          <p>
            Signin using&nbsp;
            <a
              style={{
                textDecoration: "none",
                fontSize: 15,
                fontWeight: "bold",
              }}
              href="/Login"
            >
              OTP
            </a>{" "}
          </p>
        </div>
        <div style={{ marginTop: 20, textAlign: "center" }}>
          <p>
            Don't have an account?&nbsp;
            <a
              style={{
                textDecoration: "none",
                fontSize: 15,
                fontWeight: "bold",
              }}
              href="/SignUp"
            >
              SignUp
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  );
};
